const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/oauth-clients/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { getOauthClientQueryOptions } from '@/features/settings/oauth-clients/queries/useOauthClientsQueries';
type OauthClientDetailsSearch = {
  reveal?: boolean;
};
export const Route = createFileRoute('/(app)/org/$org/settings/oauth-clients/$id')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): OauthClientDetailsSearch => ({
    reveal: search.reveal === true || search.reveal === 'true' ? true : undefined
  }),
  loader: async ({
    params: {
      id
    },
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    const fallback = i18n.t($ => $.common.settings.oauthClients.title);
    try {
      const client = await queryClient.ensureQueryData(getOauthClientQueryOptions(id));
      return {
        crumb: client.displayName || fallback
      };
    } catch {
      return {
        crumb: fallback
      };
    }
  }
});